var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "BaseFormField",
    {
      attrs: {
        label: _vm.label,
        "hide-label": _vm.hideLabel,
        "hide-form-group": _vm.hideFormGroup
      }
    },
    [
      _c("div", { class: _vm.classForInput }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.valueMin,
              expression: "valueMin"
            }
          ],
          staticClass: "form-control",
          attrs: {
            placeholder: _vm.placeholderMin,
            required: _vm.requireMin,
            min: _vm.min,
            max: _vm.valueMax
          },
          domProps: { value: _vm.valueMin },
          on: {
            change: _vm.onChange,
            input: function($event) {
              if ($event.target.composing) return
              _vm.valueMin = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.classForInput }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.valueMax,
              expression: "valueMax"
            }
          ],
          staticClass: "form-control",
          attrs: {
            placeholder: _vm.placeholderMax,
            required: _vm.requireMax,
            min: _vm.valueMin,
            max: _vm.max
          },
          domProps: { value: _vm.valueMax },
          on: {
            change: _vm.onChange,
            input: function($event) {
              if ($event.target.composing) return
              _vm.valueMax = $event.target.value
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }